









import Header from './components/Header.vue'
import BasePage from '@/components/layout/BasePage.vue'

export default {
  components: {
    BasePage,
    Header
  }
}
